import { BreadcrumComponent } from '../components/breadcrum/breadcrum.component';
import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ChangeDetectorRef,
  model,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from '../shared/services/api.service';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PaginationComponent } from '../shared/components/pagination/pagination.component';
import { Router } from '@angular/router';
import { LoaderService } from '../shared/services/loader.service';

@Component({
  selector: 'app-my-garage',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationComponent,
    BreadcrumComponent,
  ],
  templateUrl: './my-garage.component.html',
  styleUrl: './my-garage.component.scss',
})
export class MyGarageComponent {
  @Input() isStandalone: boolean = true;
  garageBreadcrumbs: any[] = [{ label: 'My Garage', url: null }];
  sub: Subscription = new Subscription();

  vehicleForm!: FormGroup;
  myGarage: any[] = [];

  selectedEditIndex: number | null = null;
  selectedVehicleIndex: number | null = null;
  isEditing: boolean = false;
  showDropdown = false;
  showActionHeader = true;
  editordelete = false;
  showPanel = false;
  showConfirmation = false;
  previewData: any;
  currentPage = 1;
  totalPagesValue = 0;
  currentPageValue = 1;
  showPagination = true;
  limit = 10;
  offset = 0;
  sortBy: string = '';
  searchText: string = '';

  totalResult: any;
  isResult: boolean = false;
  searchkey: boolean = false;
  pageType: string = 'addVehicle';
  isMobile: boolean = false;
  isRegistrationNoEntered: boolean = false;
  noVehicleFound: boolean = false;
  constructor(
    private router: Router,
    private apiService: ApiService,
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private cdr: ChangeDetectorRef
  ) {}
  ngOnInit() {
    this.getGarage();
    this.getBrandList();

    this.vehicleForm = this.fb.group({
      reg_no: ['', [Validators.pattern(/^[A-Za-z0-9]*$/), this.noLeadingSpaceValidator()]],
      make: [null, Validators.required],
      model: [null, Validators.required],
      year_of_manufacturing: [null, Validators.required],
      variant: [null, Validators.required],
    });

    // Subscribe to registration number changes
    this.vehicleForm.get('reg_no')?.valueChanges.subscribe((value) => {
      this.handleRegistrationNoChange(value);
    });
  }

  // Custom validator to prevent leading spaces
  noLeadingSpaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // Don't validate empty values
      }
      const value = control.value as string;
      // Check if value starts with a space
      if (value.trimStart() !== value) {
        return { leadingSpace: true };
      }
      // Check if value contains any spaces
      if (value.includes(' ')) {
        return { containsSpace: true };
      }
      return null;
    };
  }

  // Method to prevent leading spaces on input and convert to uppercase
  preventLeadingSpace(event: any): void {
    const input = event.target;
    let value = input.value;
    
    // Convert to uppercase
    if (value) {
      value = value.toUpperCase();
    }
    
    // Remove leading spaces
    if (value && value.trimStart() !== value) {
      value = value.trimStart();
    }
    
    // Remove any spaces from the value
    if (value && value.includes(' ')) {
      value = value.replace(/\s/g, '');
    }
    
    // Update form value if changed (this will trigger valueChanges subscription)
    if (input.value !== value) {
      this.vehicleForm.patchValue({ reg_no: value }, { emitEvent: true });
      // Update the input value directly to reflect the change
      input.value = value;
    }
  }

  // Method to handle keydown to prevent space at the start
  onRegistrationNoKeydown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const cursorPosition = input.selectionStart || 0;
    
    // Prevent space if cursor is at the start or if space is pressed
    if (event.key === ' ' && cursorPosition === 0) {
      event.preventDefault();
    }
  }

  brands: any[] = [];
  modelList: any[] = [];
  yearList: string[] = [];
  varientList: any[] = [];

  @ViewChildren('cardWrapper') cardWrappers: QueryList<ElementRef> | undefined;
  @ViewChildren('editMenu') editMenus!: QueryList<ElementRef> | undefined;

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: HTMLElement) {
    const clickedInsideCard =
      this.cardWrappers?.some((wrapper) =>
        wrapper.nativeElement.contains(target)
      ) ?? false;

    const clickedInsideMenu =
      this.editMenus?.some((menu) => menu.nativeElement.contains(target)) ??
      false;

    if (!clickedInsideCard && !clickedInsideMenu) {
      this.selectedEditIndex = null;
    }
  }

   @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkMobileView();
  }

  private checkMobileView() {
    this.isMobile = window.innerWidth <= 768;
  }

  togglePanel() {
    this.showPanel = !this.showPanel;
    this.showConfirmation = false;
    this.resetForm();
  }

  addVehicle() {
    this.vehicleForm.reset({
      reg_no: '',
      make: '',
      model: '',
      year_of_manufacturing: '',
      variant: '',
    });
  }

toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  selectOption(value: string) {
    const sortMap: { [key: string]: string } = {
      recent: 'recently_added',
      old: 'old_to_new',
      new: 'new_to_old',
      two_wheeler: 'two_wheeler',
      four_wheeler: 'four_wheeler',
    };

    if (sortMap[value]) {
      this.sortBy = sortMap[value];
      // reset to first page on sort change
      this.currentPage = 1;
      this.currentPageValue = 1;
      this.offset = 0;
      this.getGarage();
    }

    this.showDropdown = false;
  }

  closeActionHeader() {
    this.selectedEditIndex = null;
    this.showActionHeader = false;
  }

  closePanel() {
    this.showPanel = false;

    this.isEditing = false;
    this.showConfirmation = false;
    this.selectedVehicleIndex = null;
    this.isRegistrationNoEntered = false;
    this.vehicleForm.reset({
      reg_no: '',
      make: '',
      model: '',
      year_of_manufacturing: '',
      variant: '',
    });
    this.enableAllFields();
  }

  savePanel() {
    this.previewData = this.vehicleForm.value;

    this.showConfirmation = true;
  }

  edittoggle(index: number): void {
    this.selectedEditIndex = this.selectedEditIndex === index ? null : index;
  }

  get isSearchActive(): boolean {
    return this.searchText?.trim().length > 0;
  }

  get isAnyFilterSelected(): boolean {
    return !!(this.searchText || this.sortBy || this.currentPageValue > 1);
  }

  editvehicle(action: string, index: number) {
    const vehicleData = this.myGarage[index];

    if (action === 'edit') {
      this.selectedVehicleIndex = index;
      this.isEditing = true;
      this.selectedEditIndex = null;

      // Clear previous dropdown data
      this.modelList = [];
      this.varientList = [];
      this.yearList = [];

      // Reset form completely
      this.vehicleForm.reset({
        reg_no: '',
        make: '',
        model: '',
        year_of_manufacturing: '',
        variant: '',
      });
      
      // Enable all fields for editing
      this.enableAllFields();
      this.isRegistrationNoEntered = false;

      // Patch basic fields immediately
      this.vehicleForm.patchValue({
        reg_no: vehicleData.reg_no,
        make: vehicleData.make,
        year_of_manufacturing: vehicleData.year_of_manufacturing?.toString(),
      });
      this.vehicleForm.updateValueAndValidity({ emitEvent: true });
      this.cdr.detectChanges();

      // Open the panel before async data loads so bindings render immediately
      this.showPanel = true;

      // Load models for this specific vehicle
      this.loadModelsForEdit(vehicleData);
    }

    if (action === 'delete') {
      const payload = {
        action_type: 'delete',
        garage_id: Number(vehicleData.id),
      };
      this.loaderService.show();

      this.apiService.createGarage(payload).subscribe({
        next: (res) => {
          this.loaderService.hide();
          if (res.success) {
            this.totalResult = this.totalResult - 1;

            // Check if current page is still valid
            if (this.offset >= this.totalResult) {
              this.offset = Math.max(0, this.offset - this.limit);
            }

            this.getGarage(); // reload page with correct offset
            this.selectedEditIndex = null;
          } else {
          }
        },
        error: (err) => {
          this.loaderService.hide();
          if (err.error?.success) {
            this.totalResult = this.totalResult - 1;

            if (this.offset >= this.totalResult) {
              this.offset = Math.max(0, this.offset - this.limit);
            }

            this.getGarage();
            this.selectedEditIndex = null;
          } else {
            console.error('Error deleting vehicle:', err);
          }
        },
      });
    }
  }

  // Load models during edit, then patch the model field
  loadModelsForEdit(vehicleData: any) {
    const payload = {
      action_type: 'model',
      make_list: [vehicleData.make],
      model_list: [],
      variant_list: [],
      year_of_manufacture: [],
      offset: 0,
      limit: 50,
    };
   this.loaderService.show();
    this.apiService.getBrand(payload).subscribe({
      next: (res) => {
        this.loaderService.hide();
        if (res.success && res.data?.Vehicle_Models) {
          const rawModels = res.data.Vehicle_Models;
          // Use the same structure as onBrandSelect for consistency
          this.modelList = Object.values(rawModels)
            .flat()
            .map((item: any) => ({
              model_name: item.PARENT_MODEL_s || item,
            }));

          this.vehicleForm.patchValue({
            model: vehicleData.model,
          });
          this.vehicleForm.updateValueAndValidity({ emitEvent: true });
          this.cdr.detectChanges();

          // Load variants after model is set
          this.loadVariantsForEdit(vehicleData);
        } else {
          this.modelList = [];
          console.error('No models found for brand:', vehicleData.make);
        }
      },
      error: (err) => {
        this.loaderService.hide();
        console.error('Failed to fetch models during edit', err);
        this.modelList = [];
      },
    });
  }

  loadYearsForEdit(vehicleData: any) {
    const payload = {
      action_type: 'year_of_manufacture',
      make_list: [vehicleData.make],
      model_list: [vehicleData.model],
      variant_list: [],
      year_of_manufacture: [],
      offset: 0,
      limit: 50,
    };
       this.loaderService.show();

    this.apiService.getBrand(payload).subscribe({
      next: (res) => {
        if (res.success && res.data?.Vehicle_Year) {
          const rawYears = res.data.Vehicle_Year || [];
          this.yearList = rawYears
            .map(
              (item: { YEAR_OF_MANUFACTURE_s: string }) =>
                item.YEAR_OF_MANUFACTURE_s
            )
            .sort((a: string, b: string) => +b - +a)
            .map((y: string) => y.toString());

          this.vehicleForm.patchValue({
            year_of_manufacturing:
              vehicleData.year_of_manufacturing?.toString(),
          });
          this.vehicleForm.updateValueAndValidity({ emitEvent: true });
          this.cdr.detectChanges();
        } else {
          this.yearList = [];
          console.error(
            'No years found for:',
            vehicleData.make,
            vehicleData.model
          );
        }
        this.loaderService.hide();
      },
      error: (err) => {
        this.loaderService.hide();
        console.error('Failed to fetch years during edit', err);
        this.yearList = [];
      },
    });
  }

  // Load variants during edit, then patch the variant field
  loadVariantsForEdit(vehicleData: any) {
    const payload = {
      action_type: 'variant',
      make_list: [vehicleData.make],
      model_list: [vehicleData.model],
      year_of_manufacture: [],
      variant_list: [],
      offset: 0,
      limit: 50,
    };
   this.loaderService.show();
    this.apiService.getBrand(payload).subscribe({
      next: (res) => {
        if (res.success && res.data?.Vehicle_Variant) {
          const rawVariants = res.data.Vehicle_Variant;
          this.varientList = Object.values(rawVariants)
            .flat()
            .map((v) => ({ variant_name: v }));

          // Load years after variants are loaded
          this.loadYearsForEdit(vehicleData);
          this.vehicleForm.patchValue({
            variant: vehicleData.variant,
          });
          this.vehicleForm.updateValueAndValidity({ emitEvent: true });
          this.cdr.detectChanges();
        } else {
          this.varientList = [];
          console.error(
            'No variants found for:',
            vehicleData.make,
            vehicleData.model
          );
        }
        this.loaderService.hide();
      },
      error: (err) => {
        this.loaderService.hide();
        console.error('Failed to fetch variants during edit', err);
        this.varientList = [];
      },
    });
  }

  // On update button click
  updateVehicle() {
    // Use getRawValue() to get values including disabled fields
    const formValue = this.vehicleForm.getRawValue();
    
    // Check if form is valid (considering disabled fields)
    if (!this.isFormValidForSubmission() || this.selectedVehicleIndex === null) {
      return;
    }

    const vehicleData = this.myGarage[this.selectedVehicleIndex];

    const payload = {
      action_type: 'edit',
      garage_id: vehicleData.id,
      reg_no: formValue.reg_no,
      make: formValue.make,
      model: formValue.model,
      variant: formValue.variant,
      year_of_manufacturing: Number(formValue.year_of_manufacturing),
    };
       this.loaderService.show();

    this.apiService.createGarage(payload).subscribe({
      next: (res) => {
        // Update local myGarage array so UI reflects changes
        if (this.selectedVehicleIndex !== null) {
          this.myGarage[this.selectedVehicleIndex] = {
            ...vehicleData,
            ...payload,
          };
        }
        if (this.isEditing) {
          this.closePanel();
        }
        this.loaderService.hide();

        this.isEditing = false;
        this.showPanel = false;
        this.selectedVehicleIndex = null;
      },
      error: (err) => {
        this.loaderService.hide();
        console.error('Failed to update garage', err);
      },
    });
  }

  private resetForm() {
    this.isEditing = false;
    this.selectedVehicleIndex = null;
    this.isRegistrationNoEntered = false;
    this.noVehicleFound = false;
    this.enableAllFields();
  }

  private prepareAddForm(): void {
    this.isEditing = false;
    this.showPanel = false;
    this.showConfirmation = false;
    this.isRegistrationNoEntered = false;
    this.noVehicleFound = false;
    // Clear dependent dropdowns
    this.modelList = [];
    this.varientList = [];
    this.yearList = [];

    // Reset reactive form to pristine empty state
    if (this.vehicleForm) {
      this.vehicleForm.reset({
        reg_no: '',
        make: '',
        model: '',
        year_of_manufacturing: '',
        variant: '',
      });
      this.vehicleForm.markAsPristine();
      this.vehicleForm.markAsUntouched();
      this.vehicleForm.updateValueAndValidity();
      // Ensure all fields are enabled
      this.enableAllFields();
    }

    // Ensure brands are available for selection
    if (!this.brands || this.brands.length === 0) {
      this.getBrandList();
    }
  }

  isFormValid(): boolean {
    // Check if form is valid, considering disabled fields
    return this.isFormValidForSubmission();
  }

  isFormValidForSubmission(): boolean {
    // If registration number is entered and fields are disabled, 
    // check if all required fields have values using getRawValue()
    if (this.isRegistrationNoEntered) {
      const formValue = this.vehicleForm.getRawValue();
      return !!(
        formValue.reg_no &&
        formValue.make &&
        formValue.model &&
        formValue.year_of_manufacturing &&
        formValue.variant
      );
    }
    // Otherwise, use standard form validation
    return this.vehicleForm.valid;
  }

  onAddVehicle() {
    this.prepareAddForm();
  }

  openAddVehiclePanel(): void {
    this.isEditing = false;
    this.selectedVehicleIndex = null;
    this.showConfirmation = false;
    this.prepareAddForm();
    this.showPanel = true;
    this.cdr.detectChanges();
  }
  // Get Brand List (Make)

  getBrandList() {
   const payload = {
      action_type: 'make',
      make_list: [],
      model_list: [],
      variant_list: [],
      year_of_manufacture: "",
      offset: 0,
      limit: 10,
    };

       this.loaderService.show();

    this.apiService.getBrand(payload).subscribe({
      next: (res) => {
        if (res.success && Array.isArray(res.data?.Vehicle_Brands_List)) {
          // Extract brand names from each object
          this.brands = res.data.Vehicle_Brands_List.map(
            (item: { VEHICLE_MAKE_s: string }) => ({
              brand_name: item.VEHICLE_MAKE_s,
            })
          );
        } else {
          this.brands = [];
        }
        this.loaderService.hide();
      },
      error: (err) => console.error('Failed to fetch brands', err),
    });
  }

  // Get Models Based on Selected Brand
  // Improved onBrandSelect method
  onBrandSelect(event: any) {
     const selectedBrand =
      event.target?.value || this.vehicleForm.get('make')?.value;

    if (!selectedBrand) {
      this.modelList = [];
      this.yearList = [];
      this.varientList = [];
      this.vehicleForm.patchValue({ model: '', year_of_manufacturing: '', variant: '' });
      return;
    }

    const payload = {
      action_type: 'model',
      make_list: [selectedBrand],
      model_list: [],
      variant_list: [],
      year_of_manufacture: '',
      offset: 0,
      limit: 10,
    };
   this.loaderService.show();
    this.apiService.getBrand(payload).subscribe({
      next: (res) => {
        if (res.data) {
          // Extract model names from each object
          this.modelList = res.data?.Vehicle_Models_List.map(
            (item: { PARENT_MODEL_s: string }) => ({
              model_name: item.PARENT_MODEL_s,
            })
          );
        } else {
          this.modelList = [];
        }
        this.loaderService.hide();

        // Reset dependent fields
        this.yearList = [];
        this.varientList = [];
        this.vehicleForm.patchValue({ model: '', year_of_manufacturing: '', variant: '' });
      },
      error: (err) => {
        console.error('Failed to fetch models', err);
        this.modelList = [];
        this.yearList = [];
        this.varientList = [];
        this.loaderService.hide();
      },
    });
  }

  
  // Improved onModelSelect method
  onModelSelect(event: any) {
    const selectedBrand = this.vehicleForm.get('make')?.value;
    const selectedModel = event.target?.value || this.vehicleForm.get('model')?.value;

    if (!selectedBrand || !selectedModel) {
      this.yearList = [];
      this.varientList = [];
      this.vehicleForm.patchValue({ year_of_manufacturing: '', variant: ''  });
      return;
    }

    const payload = {
      action_type: 'year_of_manufacture',
      make_list: [selectedBrand],
      model_list: [selectedModel],
      variant_list: [],
      year_of_manufacture: '',
      offset: 0,
      limit: 10,
    };
       this.loaderService.show();

    this.apiService.getBrand(payload).subscribe({
      next: (res) => {
        if (res.data) {
          // Extract years from each object
          this.yearList = res.data?.Vehicle_Year.map(
            (item: { YEAR_OF_MANUFACTURE_s: string }) =>
              item.YEAR_OF_MANUFACTURE_s
          );
        } else {
          this.yearList = [];
        }

        // Reset dependent fields
        this.varientList = [];
        this.vehicleForm.patchValue({ year: '', category: '' });
        this.loaderService.hide();
      },
      error: (err) => {
        console.error('Failed to fetch years', err), (this.yearList = []);
        this.varientList = [];
        this.loaderService.hide();
      },
    });
  }
  getYearList(event: any) {
    const selectedBrand = this.vehicleForm.get('make')?.value;
    const selectedModel = this.vehicleForm.get('model')?.value;
    const selectedYear =
      event.target?.value || this.vehicleForm.get('year_of_manufacturing')?.value;

    if (!selectedBrand || !selectedModel || !selectedYear) {
      this.varientList = [];
      this.vehicleForm.patchValue({ variant: '' });
      return;
    }

    const payload = {
      action_type: 'variant',
      make_list: [selectedBrand],
      model_list: [selectedModel],
      variant_list: [],
      year_of_manufacture: selectedYear,
      offset: 0,
      limit: 10,
    };
       this.loaderService.show();
    this.apiService.getBrand(payload).subscribe({
      next: (res) => {
        if (res.data) {
          // Extract category names from each object
          this.varientList = res.data?.Vehicle_Variant_List.map(
            (item: { VARIANT_s: string }) => ({
              variant_name: item.VARIANT_s,
            })
          );
        } else {
          this.varientList = [];
        }
        // Reset dependent field
        this.vehicleForm.patchValue({ category: '' });
        this.loaderService.hide();
      },
      error: (err) => {
        console.error('Failed to fetch categories', err);
        this.varientList = [];
        this.loaderService.hide();
      },
    });
  }

  onVariantSelect(event: any) {
    const selectedBrand = this.vehicleForm.get('make')?.value;
    const selectedModel = this.vehicleForm.get('model')?.value;
    const selectedYear = this.vehicleForm.get('year_of_manufacturing')?.value;
    const selectedVariant =
      event.target?.value || this.vehicleForm.get('variant')?.value;

    if (
      !selectedBrand ||
      !selectedModel ||
      !selectedYear ||
      !selectedVariant
    ) {
      this.vehicleForm.patchValue({ variant: '' });
      return;
    }

    const payload = {
      action_type: 'Get Vehicle Details',
      make_list: [selectedBrand],
      model_list: [selectedModel],
      variant_list: [selectedVariant],
      year_of_manufacture: selectedYear,
      offset: 0,
      limit: 10,
    };
       this.loaderService.show();

    this.apiService.getBrand(payload).subscribe({
      next: (res) => {
        if (res?.success) {
          // API returned success
          this.previewData = res?.data?.[0] || {};
          // this.showConfirmation = true;
        } else {
          console.warn('No data found:', res?.data?.msg);
        }
        this.loaderService.hide();
      },
      error: (err) => {
        console.error('Failed to proceed', err);
        this.loaderService.hide();
      },
    });
  }

  // On Proceed – Get Full Vehicle Details
  onProceed() {
    // Use getRawValue() to get values including disabled fields
    const formValue = this.vehicleForm.getRawValue();
    const selectedBrand = formValue.make;
    const selectedModel = formValue.model;
    const selectedYear = formValue.year_of_manufacturing;
    const selectedVariant = formValue.variant;


    const payload = {
      action_type: 'Get Vehicle Details',
      make_list: [selectedBrand],
      model_list: [selectedModel],
      year_of_manufacture: selectedYear,
      variant_list: [selectedVariant],

      offset: 0,
      limit: 10,
    };
   this.loaderService.show();
    this.apiService.getBrand(payload).subscribe({
      next: (res) => {
        if (res.success) {
          this.previewData = res?.data?.Vehicle_Data?.[0] || {};
          this.showConfirmation = true;
        } else {
          this.previewData = {};
          console.warn('No data found:', res?.data?.msg);
        }
        this.loaderService.hide();
      },
      error: (err) => {
        console.error('Failed to proceed', err);
        this.loaderService.hide();
      },
    });
  }

  confirmAdd() {
    // Use getRawValue() to get values including disabled fields
    const formValue = this.vehicleForm.getRawValue();
    let regno = formValue.reg_no;
    let brand = formValue.make;
    let model = formValue.model;
    let year = formValue.year_of_manufacturing;
    let variant = formValue.variant;

    const payload = {
      action_type: 'add',
      reg_no: regno,
      make: brand,
      model: model,
      variant: variant,
      year_of_manufacturing: year,
    };
    this.loaderService.show();

    this.apiService.createGarage(payload).subscribe({
      next: (res) => {
        if (res.success) {
          this.vehicleForm.reset();
          this.getGarage();
        } else {
          console.error('Failed to add vehicle:', res);
        }
        this.loaderService.hide();
      },
      error: (err) => {
        console.error('Error while adding vehicle:', err);
        this.loaderService.hide();
      },
    });

    this.closePanel();
  }

  getGarage() {
    this.loaderService.show();

    const payload: any = {
      limit: this.limit,
      offset: this.offset,
      sort_by: this.sortBy,
      search_text: this.searchText,
    };
    if (this.searchText || this.sortBy) {
      this.searchkey = true;
    }
    this.sub.add(
      this.apiService.get_garage(payload).subscribe({
        next: (res) => {
          if (res.success) {
            this.myGarage = res?.data;
            this.totalResult = res?.total_result;
            this.totalPagesValue = Math.ceil(this.totalResult / this.limit);
            // If no items remain and no filters are selected, prepare the add form
            if (this.myGarage.length === 0 && !this.isAnyFilterSelected) {
              this.prepareAddForm();
            }
            //this.isResult=false
          } else {
            this.myGarage = [];
            this.totalResult = 0;
            this.totalPagesValue = 0;
            //this.isResult=true
            if (!this.isAnyFilterSelected) {
              this.prepareAddForm();
            }
          }
          this.loaderService.hide();
        },
        error: (err) => {
          console.error('Failed to proceed', err);
        },
      })
    );
  }
  handlePageChange(page: number) {
    this.currentPageValue = page;
    this.currentPage = page;
    this.offset = (page - 1) * this.limit;
    this.getGarage();
  }

  triggerSearch() {
    this.currentPage = 1;
    this.currentPageValue = 1;
    this.offset = 0;
    this.getGarage();
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  onSearchChange(value: string) {
    if (!value || !value.trim()) {
      this.searchText = '';
      this.currentPage = 1;
      this.currentPageValue = 1;
      this.offset = 0;
      this.getGarage();
    }
  }
  gotoProductlist(vehicleData?: any) {
    const MyGarageData = {
      reg_no: vehicleData?.reg_no,
      make: vehicleData?.make,
      model: vehicleData?.model,
      variant: vehicleData?.variant,
      year_of_manufacturing: vehicleData?.year_of_manufacturing?.toString(),
      part_type: vehicleData?.part_type,
    };
    // localStorage.setItem('categoryType', JSON.stringify('Used Part'));

    localStorage.removeItem('category');
    localStorage.removeItem('seemore');
    localStorage.removeItem('categoryType');
    localStorage.removeItem('guideSearchData');
         localStorage.removeItem('mostSearchedModel');
localStorage.removeItem('SpareCategory');
    localStorage.removeItem('filterState');
    localStorage.removeItem('MyGarageData');


    localStorage.setItem('MyGarageData', JSON.stringify(MyGarageData));

    this.router.navigate(['/product-list']);
    if (this.myGarage.length === 0) {
    }
  }

  handleRegistrationNoChange(value: string | null): void {
    const regNo = value?.trim() || '';
  
    // If registration number is cleared, enable all fields
    if (!regNo || regNo.length === 0) {
      // Reset form values that were bound from API
      this.vehicleForm.patchValue({
        make: '',
        model: '',
        variant: '',
        year_of_manufacturing: ''
      }, { emitEvent: false });
      
      // Clear dependent dropdowns
      this.modelList = [];
      this.varientList = [];
      this.yearList = [];
      
      // Enable all fields
      this.enableAllFields();
      this.isRegistrationNoEntered = false;
      this.noVehicleFound = false; // Reset error message when field is cleared
      return;
    }

    // If registration number has any value, disable all dropdowns immediately
    if (regNo.length > 0) {
      this.disableAllFields();
      this.isRegistrationNoEntered = true;
    }
  
    // Only call API when exactly 10 characters are entered
    if (regNo.length === 10) {
      const payload = {
        reg_no: regNo,
        action_type: "Get Vehicle Details",
      };
    
      this.loaderService.show();
    
      this.apiService.getBrand(payload).subscribe({
        next: (res: any) => {
          this.loaderService.hide();
    
          if(res?.success && res.data?.Vehicle_Data?.[0]){
            const vehicle = res.data.Vehicle_Data[0];
            const make = vehicle?.VEHICLE_MAKE_s || '';
            const model = vehicle?.PARENT_MODEL_s || '';
            const variant = vehicle?.VARIANT_s || '';
            const year = vehicle?.YEAR_OF_MANUFACTURE_s || '';
            
            // First, enable all fields to ensure validation works
            this.enableAllFields();
            
            // Patch the make first
            this.vehicleForm.patchValue({ make }, { emitEvent: false });
            
            // Load models for the brand, then continue with years and variants
            this.loadModelsForRegistration(make, model, variant, year);
          } else {
            // If API fails, keep fields disabled (since registration has value)
            this.disableAllFields();
            this.isRegistrationNoEntered = true;
            this.noVehicleFound = true;
          }
        },
    
        error: (error: any) => {
          this.loaderService.hide();
          console.error('Error fetching vehicle details:', error);
          // On error, keep fields disabled (since registration has value)
          this.disableAllFields();
          this.isRegistrationNoEntered = true;
          this.noVehicleFound = true; // Show error message on API error
        }
      });
    }
  }

  // Load models for registration number lookup
  loadModelsForRegistration(make: string, model: string, variant: string, year: string) {
    const payload = {
      action_type: 'model',
      make_list: [make],
      model_list: [],
      variant_list: [],
      year_of_manufacture: [],
      offset: 0,
      limit: 50,
    };
    
    this.apiService.getBrand(payload).subscribe({
      next: (res) => {
        if (res.success && res.data) {
          // Handle both response structures
          if (res.data.Vehicle_Models_List && Array.isArray(res.data.Vehicle_Models_List)) {
            // Array structure
            this.modelList = res.data.Vehicle_Models_List.map(
              (item: { PARENT_MODEL_s: string }) => ({
                model_name: item.PARENT_MODEL_s,
              })
            );
          } else if (res.data.Vehicle_Models) {
            // Object structure
            const rawModels = res.data.Vehicle_Models;
            this.modelList = Object.values(rawModels)
              .flat()
              .map((item: any) => ({
                model_name: item.PARENT_MODEL_s || item,
              }));
          } else {
            this.modelList = [];
          }
          
          // Load years after models are loaded
          this.loadYearsForRegistration(make, model, variant, year);
        } else {
          this.modelList = [];
          // Still try to patch values even if models aren't loaded
          this.patchVehicleFormValues(make, model, variant, year);
        }
      },
      error: (err) => {
        console.error('Failed to fetch models for registration', err);
        this.modelList = [];
        // Still try to patch values even if models aren't loaded
        this.patchVehicleFormValues(make, model, variant, year);
      },
    });
  }

  // Load years for registration number lookup
  loadYearsForRegistration(make: string, model: string, variant: string, year: string) {
    const payload = {
      action_type: 'year_of_manufacture',
      make_list: [make],
      model_list: [model],
      variant_list: [],
      year_of_manufacture: [],
      offset: 0,
      limit: 50,
    };

    this.apiService.getBrand(payload).subscribe({
      next: (res) => {
        if (res.success && res.data?.Vehicle_Year) {
          const rawYears = res.data.Vehicle_Year || [];
          this.yearList = rawYears
            .map((item: { YEAR_OF_MANUFACTURE_s: string }) => item.YEAR_OF_MANUFACTURE_s)
            .sort((a: string, b: string) => +b - +a)
            .map((y: string) => y.toString());
          
          // Load variants after years are loaded
          this.loadVariantsForRegistration(make, model, variant, year);
        } else {
          this.yearList = [];
          // Still try to patch values even if years aren't loaded
          this.patchVehicleFormValues(make, model, variant, year);
        }
      },
      error: (err) => {
        console.error('Failed to fetch years for registration', err);
        this.yearList = [];
        // Still try to patch values even if years aren't loaded
        this.patchVehicleFormValues(make, model, variant, year);
      },
    });
  }

  // Load variants for registration number lookup
  loadVariantsForRegistration(make: string, model: string, variant: string, year: string) {
    const payload = {
      action_type: 'variant',
      make_list: [make],
      model_list: [model],
      year_of_manufacture: year,
      variant_list: [],
      offset: 0,
      limit: 50,
    };
    
    this.apiService.getBrand(payload).subscribe({
      next: (res) => {
        if (res.success && res.data) {
          // Handle both response structures
          if (res.data.Vehicle_Variant_List && Array.isArray(res.data.Vehicle_Variant_List)) {
            // Array structure
            this.varientList = res.data.Vehicle_Variant_List.map(
              (item: { VARIANT_s: string }) => ({
                variant_name: item.VARIANT_s,
              })
            );
          } else if (res.data.Vehicle_Variant) {
            // Object structure
            const rawVariants = res.data.Vehicle_Variant;
            this.varientList = Object.values(rawVariants)
              .flat()
              .map((v) => ({ variant_name: v }));
          } else {
            this.varientList = [];
          }
        } else {
          this.varientList = [];
        }
        
        // Now patch all form values and disable fields
        this.patchVehicleFormValues(make, model, variant, year);
      },
      error: (err) => {
        console.error('Failed to fetch variants for registration', err);
        this.varientList = [];
        // Still patch values even if variants aren't loaded
        this.patchVehicleFormValues(make, model, variant, year);
      },
    });
  }

  // Patch form values after all dropdowns are loaded
  patchVehicleFormValues(make: string, model: string, variant: string, year: string) {
    // Patch all values at once
    this.vehicleForm.patchValue({
      make: make || '',
      model: model || '',
      variant: variant || '',
      year_of_manufacturing: year || '',
    }, { emitEvent: false });
    
    // Update validity after patching
    this.vehicleForm.updateValueAndValidity({ emitEvent: false });
    
    // Trigger change detection to update the UI
    this.cdr.detectChanges();
    
    // Now disable all fields
    this.disableAllFields();
    this.isRegistrationNoEntered = true;
    this.noVehicleFound = false;
  }

  disableAllFields(): void {
    // this.vehicleForm.get('reg_no')?.disable({ emitEvent: false });
    this.vehicleForm.get('make')?.disable({ emitEvent: false });
    this.vehicleForm.get('model')?.disable({ emitEvent: false });
    this.vehicleForm.get('year_of_manufacturing')?.disable({ emitEvent: false });
    this.vehicleForm.get('variant')?.disable({ emitEvent: false });
  }

  enableAllFields(): void {
    this.vehicleForm.get('reg_no')?.enable({ emitEvent: false });
    this.vehicleForm.get('make')?.enable({ emitEvent: false });
    this.vehicleForm.get('model')?.enable({ emitEvent: false });
    this.vehicleForm.get('year_of_manufacturing')?.enable({ emitEvent: false });
    this.vehicleForm.get('variant')?.enable({ emitEvent: false });
  }
  
}
